import { UserRoles } from '@dynamika-shared/types/auth';
import { FC } from 'react';
import {
  CircleIcon,
  DoubleCircleIcon,
  HexagonIcon,
  HexagonStarIcon,
  PentagonIcon,
  RhombusIcon,
  SquareIcon,
  TriangleIcon,
} from '@dynamika-shared/ui/icons';

type UserMenuIconsProps = {
  icon: string | undefined;
};

export const UserMenuIcons: FC<UserMenuIconsProps> = ({ icon }) => {
  const roleSpace = 'Role Space';
  const primaryClassName = 'leading-10 ml-1 text-1624 font-medium';
  const wrapperClassName = 'group flex items-center w-full cursor-pointer';

  switch (icon) {
    case UserRoles.SITE:
      return (
        <div className={wrapperClassName}>
          <RhombusIcon className='text-munsellPurple w-2.5 h-2.5 ' />
          <p className={primaryClassName}>{'Site ' + roleSpace}</p>
        </div>
      );
    case UserRoles.PROJECT_MANAGER:
      return (
        <div className={wrapperClassName}>
          <HexagonIcon className='text-vividTangelo w-2.5 h-2.5' />
          <p className={primaryClassName}>{'PM ' + roleSpace}</p>
        </div>
      );
    case UserRoles.IMAGING_SPECIALIST:
      return (
        <div className={wrapperClassName}>
          <TriangleIcon className='text-honoluluBlue w-2.5 h-2.5' />
          <p className={primaryClassName}>{'QC ' + roleSpace}</p>
        </div>
      );
    case UserRoles.DATA_MANAGER:
      return (
        <div className={wrapperClassName}>
          <DoubleCircleIcon className='text-munsellPurple w-2.5 h-2.5' />
          <p className={primaryClassName}>{'Data Manager ' + roleSpace}</p>
        </div>
      );
    case UserRoles.SPONSOR:
      return (
        <div className={wrapperClassName}>
          <CircleIcon className='text-redOrange w-2.5 h-2.5' />
          <p className={primaryClassName}>{'Sponsor ' + roleSpace}</p>
        </div>
      );
    case UserRoles.READER:
      return (
        <div className={wrapperClassName}>
          <SquareIcon className='text-honoluluBlue w-2.5 h-2.5' />
          <p className={primaryClassName}>{'Reader ' + roleSpace}</p>
        </div>
      );

    case UserRoles.ADMIN:
      return (
        <div className={wrapperClassName}>
          <HexagonStarIcon className='text-redOrange w-2.5 h-2.5' />
          <p className={primaryClassName}>{'Admin ' + roleSpace}</p>
        </div>
      );
    case UserRoles.USER:
      return (
        <div className={wrapperClassName}>
          <SquareIcon className='text-honoluluBlue w-2.5 h-2.5' />
          <p className={primaryClassName}>{'User ' + roleSpace}</p>
        </div>
      );
    case UserRoles.SUPPORT:
      return (
        <div className={wrapperClassName}>
          <HexagonStarIcon className='text-redOrange w-2.5 h-2.5' />
          <p className={primaryClassName}>{'Support ' + roleSpace}</p>
        </div>
      );
    case UserRoles.VALIDATION_SPECIALIST:
      return (
        <div className={wrapperClassName}>
          <TriangleIcon className='text-munsellPurple w-2.5 h-2.5' />
          <p className={primaryClassName}>{'VS ' + roleSpace}</p>
        </div>
      );
    case UserRoles.EXTERNAL_USER:
      return (
        <div className={wrapperClassName}>
          <PentagonIcon className='text-vividTangelo w-2.5 h-2.5' />
          <p className={primaryClassName}>{'External User ' + roleSpace}</p>
        </div>
      );
    default:
      return null;
  }
};
